<svg
  width={$$props.size || '26'}
  height={$$props.size || '26'}
  viewBox="0 0 26 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.917 13V17.3333C11.917 19.1284 14.8268 20.5833 18.417 20.5833C22.0072 20.5833 24.917 19.1284 24.917 17.3333V13"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
  />
  <path
    d="M11.917 17.3333V21.6666C11.917 23.4617 14.8268 24.9166 18.417 24.9166C22.0072 24.9166 24.917 23.4617 24.917 21.6666V17.3333"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
  />
  <path
    d="M1.0835 4.33331V8.66665C1.0835 10.4617 3.99333 11.9166 7.5835 11.9166C11.1737 11.9166 14.0835 10.4617 14.0835 8.66665V4.33331"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
  />
  <path
    d="M1.0835 8.66663V13C1.0835 14.795 3.99333 16.25 7.5835 16.25C9.24858 16.25 10.7663 15.9358 11.9168 15.4212"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
  />
  <path
    d="M1.0835 13V17.3333C1.0835 19.1284 3.99333 20.5833 7.5835 20.5833C9.24858 20.5833 10.7674 20.2703 11.9168 19.7557"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.417 16.25C22.0068 16.25 24.917 14.7949 24.917 13C24.917 11.2051 22.0068 9.75 18.417 9.75C14.8271 9.75 11.917 11.2051 11.917 13C11.917 14.7949 14.8271 16.25 18.417 16.25Z"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
    stroke-linecap="square"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.5835 7.58331C11.1733 7.58331 14.0835 6.12824 14.0835 4.33331C14.0835 2.53839 11.1733 1.08331 7.5835 1.08331C3.99365 1.08331 1.0835 2.53839 1.0835 4.33331C1.0835 6.12824 3.99365 7.58331 7.5835 7.58331Z"
    stroke={$$props.stroke || '#ffffff8f'}
    stroke-width="1.1"
    stroke-linecap="square"
  />
</svg>
